<template>
<div id="contentWrap">
  <div class="content left">
    <div id="content_1block" class="left">
      <div id="content_top">
        <div class="content_title_full left">Registration</div>
      </div>
      <div class="msgblock"></div>
      <div class="pure-form pure-form-aligned">
        <fieldset style="margin-left: 80px;">

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="email">Email Address <span style="color: red">*</span></label>
            <input id="email" class="pure-input-2-3" type="email" placeholder="Email Address" v-model="userName">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="password">Password <span style="color: red">*</span></label>
            <input id="password" class="pure-input-2-3" type="password" placeholder="Password" v-model="passwd">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="confirm_password">Confirm Password  <span style="color: red">*</span></label>
            <input id="password" class="pure-input-2-3" type="password" placeholder="Confirm Password" v-model="passwdConfirm">
          </div>

          <div class="pure-controls" style="margin-left: 230px;">
            <button type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="cancel()">Cancel</button>
            <button type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="register()" :disabled="isDataEmpty">Create Account</button>
          </div>
        </fieldset>
      </div>
      <modal v-if="showModal" @close="showModal = false"/>
    </div>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {
  getDataUrl,
  getSendMailUrl
} from '../../tools/getUrl.js';
import router from '../../router.js';
import Modal from '../../tools/Modal';

export default {
  components: {
    Modal
  },
  computed: {
        isDataEmpty: function() {
            if (this.userName === '' || this.passwd === '') {
                return true;
            }
            return false;
        }
    },
  data: function() {
    return {
      showModal: false,
      userName: '',
      passwd: '',
      passwdConfirm: '',
      greeting: true
    };
  },
  methods: {
    cancel: function() {
      router.push('/');
    },
    register: function() {
      var strUsername = this.userName.trim(),
        strPasswd = this.passwd.trim(),
        strPasswdConfirm = this.passwdConfirm.trim();

      var obj = {
          api: 'check_account',
          email: strUsername
        },
        url = getDataUrl(obj);
      if (strPasswd === strPasswdConfirm) {
        this.$http.get(url).then((response) => {
          // success callback
          var datums = response.data;
          if (datums == 0) {
            obj = {
              email: strUsername,
              psw: strPasswd
            };
            url = getSendMailUrl('registeractive.php', obj);
            this.showModal = true;
            this.$http.get(url).then((response) => {
              // success callback
              var datums = response.data;
              if (datums > 0) {
                sessionStorage.setItem('registerEmail', strUsername);
                sessionStorage.setItem('registerPsw', strPasswd);
                sessionStorage.setItem('registerLink', url);
                router.push('Registerresult');
              } else {
                console.log('duplicate email');
              }
            }, (response) => {
              // error callback
            });

          } else {
            alert('Email already exists.');
          }
        }, (response) => {
          // error callback
        });
      } else {
        alert('Passwords not matched.');
      }


    }
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// Register.vue?2cc57314